import Controller from '@ember/controller';
import {
  action,
  computed,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  coachingService: service(),
  store: service(),

  changeset: alias('model.changeset'),
  reportingPeriodsToGoalDate: alias(
    'model.individualRecord.reportingPeriodsToGoalDate',
  ),

  error: null,

  reset() {
    setProperties(this, {
      error: null,
    });
  },

  isOverallGoal: computed('model.field.t', function () {
    return (
      get(this, 'coachingService.overallGoalTypes')[
        get(this, 'model.field.t')
      ] || false
    );
  }),
  isIntervalGoal: computed('model.field.t', function () {
    return (
      get(this, 'coachingService.intervalGoalTypes')[
        get(this, 'model.field.t')
      ] || false
    );
  }),

  save: task(function* () {
    let changeset = this.changeset;
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        let individualRecord = get(this, 'model.individualRecord');
        let field = get(this, 'model.field');
        let { overallGoal, intervalGoal } = getProperties(
          changeset,
          'overallGoal',
          'intervalGoal',
        );
        if (isEmpty(overallGoal)) {
          delete field.overallGoal;
        } else {
          set(field, 'overallGoal', Number(overallGoal));
        }
        if (isEmpty(intervalGoal)) {
          delete field.intervalGoal;
        } else {
          if (get(field, 'intervalGoal') == null) {
            set(field, 'intervalGoal', {});
          }
          set(field, 'intervalGoal.low', Number(intervalGoal));
        }
        yield individualRecord.save();
        window.history.back();
      } catch (error) {
        set(this, 'error', error);
      }
    }
  }).drop(),

  handleOverallGoalChanged: action(function (event) {
    const val = event.target.value;
    let changeset = this.changeset;
    set(changeset, 'overallGoal', val);
    changeset.validate();
    if (get(changeset, 'isValid')) {
      let intervalGoal = this.coachingService.calculateIntervalGoal({
        individualRecord: get(this, 'model.individualRecord'),
        overallGoal: val,
      });
      set(this, 'changeset.intervalGoal', intervalGoal);
    }
  }),
});
